import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { API } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous
  const [subscription, setSubscription] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await API.get("/auth/me");
      setUser(data);
      setSubscription(data.subscription || { active: false });
    } catch {
      setUser(false);
      setSubscription(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    await API.post("/auth/login", { email, password });
    await refresh();
  };

  const register = async (name, email, password) => {
    await API.post("/auth/register", { name, email, password, accept_terms: true });
    await refresh();
  };

  const logout = async () => {
    try { await API.post("/auth/logout"); } catch { /* ignore */ }
    setUser(false);
    setSubscription(null);
  };

  const hasAccess = !!user && (user.role === "admin" || !!subscription?.active);
  const isAdmin = !!user && user.role === "admin";

  return (
    <AuthContext.Provider value={{ user, subscription, hasAccess, isAdmin, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
